import ScrollTrigger from 'gsap/ScrollTrigger';
import LocomotiveScroll from 'locomotive-scroll';
import isIE from '../utils/is-ie';

const scrollContainer = document.querySelector('[data-lit-scroll="container"]');

if (!isIE() && window.matchMedia('(min-width: 1025px)').matches) {
    const locoScroll = new LocomotiveScroll({
        el: scrollContainer,
        lerp: 0.05,
        smooth: true,
        tablet: {
            smooth: false,
        },
        mobile: {
            smooth: false,
        },
    });

    locoScroll.on('scroll', ScrollTrigger.update);

    if ('ResizeObserver' in window) {
        const ro = new ResizeObserver((entries) => {
            entries.forEach(() => {
                locoScroll.update();
            });
        });

        ro.observe(scrollContainer);
    } else {
        setTimeout(() => {
            locoScroll.update();
        }, 1000);
    }

    ScrollTrigger.defaults({
        scroller: scrollContainer,
    });

    ScrollTrigger.scrollerProxy(scrollContainer, {
        scrollTop(value) {
            return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
        }, // we don't have to define a scrollLeft because we're only scrolling vertically.
        getBoundingClientRect() {
            return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
        },
        pinType: scrollContainer.style.transform ? 'transform' : 'fixed',
    });
}
